const GRID_PATH =
  'M25.9617 18.6113H32.2254V11.1113H25.9617V18.6113ZM16.8504 18.6113H23.17V11.1113H16.8504V18.6113ZM7.80875 18.6113H14.0729V11.1113H7.80875V18.6113ZM7.80875 28.8888H14.0729V21.3888H7.80875V28.8888ZM16.8504 28.8888H23.17V21.3888H16.8504V28.8888ZM25.9617 28.8888H32.2254V21.3888H25.9617V28.8888ZM5.03125 28.8888V11.1113C5.03125 10.3474 5.30319 9.69337 5.84708 9.14921C6.39097 8.60532 7.04486 8.33337 7.80875 8.33337H32.2254C32.9893 8.33337 33.6433 8.60532 34.1875 9.14921C34.7314 9.69337 35.0033 10.3474 35.0033 11.1113V28.8888C35.0033 29.6527 34.7314 30.3067 34.1875 30.8509C33.6433 31.3948 32.9893 31.6667 32.2254 31.6667H7.80875C7.04486 31.6667 6.39097 31.3948 5.84708 30.8509C5.30319 30.3067 5.03125 29.6527 5.03125 28.8888Z';

/**
 * Gradient square badge with a "view_module" grid glyph.
 * Ported from the Figma export (dev-mcp section2/McpIconBadge).
 */
export default function McpIconBadge({ className = '' }) {
  return (
    <div
      className={`rounded-[5px] w-[44px] h-[44px] md:w-[50px] md:h-[50px] flex items-center justify-center shrink-0 ${className}`}
      style={{
        backgroundImage:
          'linear-gradient(91.2573deg, rgb(228, 93, 89) 0%, rgb(89, 100, 160) 100%)',
      }}
    >
      <svg
        className="w-[35px] h-[35px] md:w-[40px] md:h-[40px]"
        fill="none"
        viewBox="0 0 40 40"
        aria-hidden="true"
      >
        <path d={GRID_PATH} fill="#001F40" />
      </svg>
    </div>
  );
}
